import Vue from 'vue'
import App from './App.vue'
import createRouter from './router'
import './registerServiceWorker'
import applyConverters from 'axios-case-converter'
import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import EaInput from '@/vcs/_shared/ea-input/cmp.vue'
import EaCodeInput from '@/vcs/_shared/ea-code-input/cmp.vue'
import EaSimpleSelect from '@/vcs/_shared/ea-simple-select/cmp.vue'
import VueFloatLabel from 'vue-float-label'
import Vuelidate from 'vuelidate'
import Ripple from 'vue-ripple-directive'
import i18n from './i18n'
import Version from '@/vcs/_shared/Version.vue'
import store from './stores/Store.js'
import getAuthConfig from './get-auth-config.js'
import serviceProviderStore from '@/stores/service-provider-store.js'

// INFO: most important global functions and variables encapsulated in Globals.js
import './globals/Globals.js'

window._ = _
window.moment = moment
moment.locale('pl')

Vue.config.productionTip = false

const token = window.localStorage.getItem('collectomate_token')
if (token && token.length) {
  console.log(`Bearer ${token}`)
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
} else {
  axios.defaults.headers.common['Authorization'] = ''
}
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

applyConverters(axios)

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    // if ((error || {}).message == 'Network Error') {
    //   console.log('%c HAVE A NETWORK ERROR', 'color: red;')
    //   if (router.currentRoute.path != '/offline') {
    //     router.push('/offline')
    //   }
    // }
    // Do something with response error
    return Promise.reject(error)
  },
)

Ripple.color = 'rgba(103, 201, 187, 0.4)'

// plugins
Vue.use(Vuelidate)
Vue.use(VueFloatLabel)

// components available globally (without additional imports)
Vue.component('EaInput', EaInput)
Vue.component('EaCodeInput', EaCodeInput)
Vue.component('EaSimpleSelect', EaSimpleSelect)
Vue.component('Version', Version)

// directives
Vue.directive('ripple', Ripple)

getAuthConfig()
  .then(() => {
    return {
      oktaLogin: serviceProviderStore.getters.authMethods.includes('okta'),
      clientId: serviceProviderStore.getters.oktaClientId,
      issuer: serviceProviderStore.getters.oktaIssuer,
      redirectUri: `https://${window.location.host}/login/callback`,
      scopes: ['openid', 'profile', 'email', 'phone'],
      pkce: true,
      autoRenew: true,
      maxClockSkew: 1200,
      storageKey: 'okta-token-new-storage',
      secure: false,
      storageManager: {
        token: {
          storageType: 'cookie',
          storageTypes: ['localStorage', 'sessionStorage', 'cookie'],
          useMultipleCookies: true,
        },
        cache: {
          storageType: 'cookie',
          storageTypes: ['localStorage', 'sessionStorage', 'cookie'],
        },
        transaction: {
          storageType: 'cookie',
          storageTypes: ['localStorage', 'sessionStorage', 'cookie'],
        },
      },
      tokenManager: {
        storage: 'sessionStorage',
      },
    }
  })
  .then(result => startVue(result))

function startVue(oktaConfig) {
  // eslint-disable-next-line vue/require-name-property
  window.mainApp = new Vue({
    router: createRouter(oktaConfig),
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}
